import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Argon from './plugins/argon-kit'
import './registerServiceWorker'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faGamepad,
  faStar,
  faCodeBranch,
  faIdBadge,
  faImage,
  faLocationArrow,
  faBriefcase,
  faGraduationCap,
  faLink,
  faSmile,
  faTasks,
  faUniversity,
  faCheck,
  faPlay,
  faShareAlt,
  faPeopleCarry,
  faCode,
} from '@fortawesome/free-solid-svg-icons'

import {
  faJsSquare,
  faNodeJs,
  faGithub,
  faTwitch,
  faTwitter,
  faYoutube,
  faVuejs,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faGamepad,
  faStar,
  faJsSquare,
  faNodeJs,
  faCodeBranch,
  faGithub,
  faTwitch,
  faTwitter,
  faYoutube,
  faVuejs,

  faIdBadge,
  faImage,
  faLocationArrow,
  faBriefcase,
  faGraduationCap,
  faLink,
  faSmile,
  faTasks,
  faUniversity,
  faCheck,
  faPlay,
  faShareAlt,
  faPeopleCarry,
  faCode,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(Argon)
Vue.mixin({
  methods: {
    goTo (pageName) {
      this.$router.push({
        name: pageName
      })
    }
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
